// AI-CONTEXT: See docs/features/platform-stats-trend-sparklines.md

/**
 * Builds the monthly sparkline series for one platform-stat field from the
 * PlatformStats collection docs. Docs without a `Period` (the `current`
 * singleton) and non-numeric values are dropped; the result is sorted by
 * month ascending. Sorting/filtering happens HERE, client-side — never via
 * `orderBy('Period')`, which would silently exclude docs missing the field
 * (pitfall #database-firestore-orderby-excludes-missing-field).
 *
 * @param {Array<{ Period?: string }> | null} docs - PlatformStats collection docs
 * @param {string} field - stats field name (e.g. 'MonetaryValue')
 * @returns {Array<{ month: string, value: number }>} ascending monthly series
 */
const buildPlatformStatSeries = (docs, field) => {
    if (!Array.isArray(docs)) return []

    return docs
        .filter((doc) => doc && typeof doc.Period === 'string' && doc.Period)
        .map((doc) => ({ month: doc.Period, value: doc[field] }))
        .filter((point) => Number.isFinite(point.value))
        .sort((a, b) => (a.month < b.month ? -1 : a.month > b.month ? 1 : 0))
}

export default buildPlatformStatSeries
